class FideicomisoNoEmpresarialResponseInputPipe {
  getName() {
    return 'FideicomisoNoEmpresarial';
  }

  apply(data) {
    const { Complemento = {} } = data;

    if (!Complemento.Fideicomisonoempresarial) {
      return data;
    }

    const Fideicomisonoempresarial = { ...Complemento.Fideicomisonoempresarial };

    let { DeduccOSalidas = {} } = Fideicomisonoempresarial;
    let { IngresosOEntradas = {} } = Fideicomisonoempresarial;

    data.Complemento = {
      ...Complemento,
      Fideicomisonoempresarial: {
        ...Fideicomisonoempresarial,
        IngresosOEntradas: {
          ...IngresosOEntradas,
          Concepto: IngresosOEntradas.IntegracIngresos?.Concepto,
        },
        DeduccOSalidas: {
          ...DeduccOSalidas,
          ConceptoS: DeduccOSalidas.IntegracEgresos?.ConceptoS,
        },
      },
    };

    return data;
  }
}

export default FideicomisoNoEmpresarialResponseInputPipe;
